// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── CSS Variables matching app palette ─────────────────────────────── */
:root {
    --navy:        #1a2e44;
    --teal:        #2d7d9a;
    --teal-light:  #3a9bbf;
    --teal-glow:   rgba(45, 125, 154, 0.18);
    --bg:          #e8f1f8;        /* matches the app's light blue-grey bg */
    --card-bg:     #ffffff;
    --border:      #d0e4f0;
    --text-dark:   #1a2e44;
    --text-mid:    #3d5a73;
    --text-soft:   #6b8fa8;
    --success:     #22c55e;
    --radius-lg:   16px;
    --radius-md:   10px;
    --shadow-card: 0 4px 24px rgba(26, 46, 68, 0.10), 0 1px 4px rgba(26, 46, 68, 0.06);
    --shadow-btn:  0 4px 16px rgba(45, 125, 154, 0.35);
}

/* ─── Base ────────────────────────────────────────────────────────────── */
* {
    box-sizing: border-box;
}

body {
    background: var(--bg);
    font-family: 'DM Sans', sans-serif;
}

/* ─── Container ───────────────────────────────────────────────────────── */
.checkout-container {
    max-width: 580px;
    margin: 90px auto 40px;
    padding: 32px 36px 28px;
    background: var(--card-bg);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border);
    text-align: center;
    position: relative;
    overflow: hidden;
}

/* Subtle top accent bar matching navbar teal */
.checkout-container::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--navy) 0%, var(--teal) 60%, var(--teal-light) 100%);
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

/* ─── Checkout Title ──────────────────────────────────────────────────── */
.checkout-container h2,
.checkout-container h1 {
    font-family: 'Playfair Display', serif;
    color: var(--navy);
    font-size: 1.75rem;
    font-weight: 600;
    margin: 8px 0 24px;
    letter-spacing: -0.01em;
}

/* ─── Order Summary ───────────────────────────────────────────────────── */
.order-summary {
    text-align: left;
    margin-bottom: 24px;
    background: linear-gradient(135deg, #f0f7fc 0%, #e8f1f8 100%);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    padding: 18px 20px 14px;
}

.order-summary h3,
.order-summary strong {
    font-family: 'DM Sans', sans-serif;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--teal);
    margin-bottom: 12px;
    display: block;
}

/* ─── Checkout Item ───────────────────────────────────────────────────── */
.checkout-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 11px 0;
    border-bottom: 1px dashed var(--border);
    color: var(--text-dark);
    font-size: 0.97rem;
    font-weight: 500;
}

.checkout-item:last-of-type {
    border-bottom: none;
}

.checkout-item span,
.checkout-item div {
    color: var(--text-mid);
    font-size: 0.9rem;
}

/* ─── Total Amount ────────────────────────────────────────────────────── */
.total-amount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 14px;
    padding: 12px 16px;
    background: var(--navy);
    border-radius: var(--radius-md);
    color: #ffffff;
    font-size: 1.05rem;
    font-weight: 700;
    letter-spacing: 0.01em;
}

/* ─── Payment Options ─────────────────────────────────────────────────── */
.payment-options {
    text-align: left;
    margin-bottom: 8px;
}

.payment-options h3,
.payment-options > strong,
.payment-options > p {
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--teal);
    margin-bottom: 10px;
    display: block;
}

.payment-options label {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 8px 0;
    font-size: 0.95rem;
    font-weight: 500;
    color: var(--text-dark);
    padding: 10px 14px;
    border-radius: var(--radius-md);
    border: 1.5px solid var(--border);
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
}

.payment-options label:hover {
    border-color: var(--teal);
    background: var(--teal-glow);
}

.payment-options input[type="radio"] {
    accent-color: var(--teal);
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

/* ─── Buttons ─────────────────────────────────────────────────────────── */
.checkout-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 22px;
}

.back-button-container {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 12px;
}

.back-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #f0f5f9;
    border: 1.5px solid var(--border);
    color: var(--text-mid);
    padding: 8px 16px;
    font-size: 0.9rem;
    font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    cursor: pointer;
    border-radius: var(--radius-md);
    transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.back-button:hover {
    background: var(--border);
    border-color: var(--teal);
    color: var(--navy);
}

/* Primary pay button */
.pay-button {
    background: linear-gradient(135deg, var(--navy) 0%, var(--teal) 100%);
    color: #fff;
    border: none;
    border-radius: var(--radius-md);
    padding: 14px 28px;
    font-size: 1rem;
    font-weight: 700;
    font-family: 'DM Sans', sans-serif;
    letter-spacing: 0.02em;
    cursor: pointer;
    box-shadow: var(--shadow-btn);
    transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;
    margin-top: 10px;
    width: 100%;
    position: relative;
    overflow: hidden;
}

.pay-button::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255,255,255,0);
    transition: background 0.15s;
}

.pay-button:hover:not(:disabled)::after {
    background: rgba(255,255,255,0.08);
}

.pay-button:hover:not(:disabled),
.pay-button:focus:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 22px rgba(45, 125, 154, 0.45);
}

.pay-button:active:not(:disabled) {
    transform: translateY(0);
}

.pay-button:disabled {
    background: #c8d8e4;
    cursor: not-allowed;
    color: #8faabb;
    box-shadow: none;
    opacity: 0.75;
}

/* View Orders button — same visual weight as pay */
.view-orders-button {
    background: linear-gradient(135deg, var(--navy) 0%, var(--teal) 100%);
    color: #fff;
    border: none;
    border-radius: var(--radius-md);
    padding: 14px 28px;
    font-size: 1rem;
    font-weight: 700;
    font-family: 'DM Sans', sans-serif;
    letter-spacing: 0.02em;
    cursor: pointer;
    box-shadow: var(--shadow-btn);
    transition: transform 0.15s, box-shadow 0.15s;
    width: 100%;
    position: relative;
    overflow: hidden;
}

.view-orders-button:hover,
.view-orders-button:focus {
    transform: translateY(-1px);
    box-shadow: 0 6px 22px rgba(45, 125, 154, 0.45);
}

.view-orders-button:active {
    transform: translateY(0);
}

/* ─── Responsive ──────────────────────────────────────────────────────── */
@media (max-width: 768px) {
    .checkout-container {
        margin: 80px 12px 24px;
        padding: 24px 20px 20px;
        border-radius: var(--radius-md);
        box-shadow: var(--shadow-card);
    }

    .checkout-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 3px;
        padding: 10px 0;
    }

    .payment-options label {
        font-size: 0.9rem;
    }

    .pay-button,
    .view-orders-button {
        padding: 12px 20px;
        font-size: 0.97rem;
    }
}

@media (max-width: 480px) {
    .checkout-container {
        margin: 72px 8px 20px;
        padding: 20px 14px 16px;
        border-radius: 12px;
    }

    .checkout-container h2,
    .checkout-container h1 {
        font-size: 1.45rem;
    }

    .total-amount {
        font-size: 0.97rem;
    }

    .back-button {
        padding: 7px 13px;
        font-size: 0.85rem;
    }
}

@media (max-width: 320px) {
    .checkout-container {
        margin: 68px 4px 16px;
        padding: 16px 10px 14px;
    }

    .pay-button,
    .view-orders-button {
        padding: 11px 16px;
        font-size: 0.92rem;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .checkout-container {
        max-width: 88%;
        margin: 100px auto 40px;
    }
}

@media (min-width: 1025px) and (max-width: 1280px) {
    .checkout-container {
        max-width: 640px;
        margin: 100px auto 40px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Checkout.css"],"names":[],"mappings":"AAEA,2EAA2E;AAC3E;IACI,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uCAAuC;IACvC,sBAAsB,SAAS,yCAAyC;IACxE,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kFAAkF;IAClF,kDAAkD;AACtD;;AAEA,4EAA4E;AAC5E;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA,4EAA4E;AAC5E;IACI,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;IACzB,WAAW;IACX,2FAA2F;IAC3F,oDAAoD;AACxD;;AAEA,4EAA4E;AAC5E;;IAEI,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,4EAA4E;AAC5E;IACI,gBAAgB;IAChB,mBAAmB;IACnB,6DAA6D;IAC7D,+BAA+B;IAC/B,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;;IAEI,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,uCAAuC;IACvC,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,4EAA4E;AAC5E;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;IAGI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,+BAA+B;IAC/B,iCAAiC;IACjC,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iCAAiC;IACjC,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,+BAA+B;IAC/B,6DAA6D;AACjE;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,qEAAqE;IACrE,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,sBAAsB;IACtB,eAAe;IACf,6BAA6B;IAC7B,4DAA4D;IAC5D,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA,mDAAmD;AACnD;IACI,qEAAqE;IACrE,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,sBAAsB;IACtB,eAAe;IACf,6BAA6B;IAC7B,6CAA6C;IAC7C,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,4EAA4E;AAC5E;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,uBAAuB;IAC3B;;IAEA;;QAEI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@600&display=swap');\n\n/* ─── CSS Variables matching app palette ─────────────────────────────── */\n:root {\n    --navy:        #1a2e44;\n    --teal:        #2d7d9a;\n    --teal-light:  #3a9bbf;\n    --teal-glow:   rgba(45, 125, 154, 0.18);\n    --bg:          #e8f1f8;        /* matches the app's light blue-grey bg */\n    --card-bg:     #ffffff;\n    --border:      #d0e4f0;\n    --text-dark:   #1a2e44;\n    --text-mid:    #3d5a73;\n    --text-soft:   #6b8fa8;\n    --success:     #22c55e;\n    --radius-lg:   16px;\n    --radius-md:   10px;\n    --shadow-card: 0 4px 24px rgba(26, 46, 68, 0.10), 0 1px 4px rgba(26, 46, 68, 0.06);\n    --shadow-btn:  0 4px 16px rgba(45, 125, 154, 0.35);\n}\n\n/* ─── Base ────────────────────────────────────────────────────────────── */\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    background: var(--bg);\n    font-family: 'DM Sans', sans-serif;\n}\n\n/* ─── Container ───────────────────────────────────────────────────────── */\n.checkout-container {\n    max-width: 580px;\n    margin: 90px auto 40px;\n    padding: 32px 36px 28px;\n    background: var(--card-bg);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border);\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n}\n\n/* Subtle top accent bar matching navbar teal */\n.checkout-container::before {\n    content: '';\n    position: absolute;\n    top: 0; left: 0; right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, var(--navy) 0%, var(--teal) 60%, var(--teal-light) 100%);\n    border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n/* ─── Checkout Title ──────────────────────────────────────────────────── */\n.checkout-container h2,\n.checkout-container h1 {\n    font-family: 'Playfair Display', serif;\n    color: var(--navy);\n    font-size: 1.75rem;\n    font-weight: 600;\n    margin: 8px 0 24px;\n    letter-spacing: -0.01em;\n}\n\n/* ─── Order Summary ───────────────────────────────────────────────────── */\n.order-summary {\n    text-align: left;\n    margin-bottom: 24px;\n    background: linear-gradient(135deg, #f0f7fc 0%, #e8f1f8 100%);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    padding: 18px 20px 14px;\n}\n\n.order-summary h3,\n.order-summary strong {\n    font-family: 'DM Sans', sans-serif;\n    font-size: 0.8rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--teal);\n    margin-bottom: 12px;\n    display: block;\n}\n\n/* ─── Checkout Item ───────────────────────────────────────────────────── */\n.checkout-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 11px 0;\n    border-bottom: 1px dashed var(--border);\n    color: var(--text-dark);\n    font-size: 0.97rem;\n    font-weight: 500;\n}\n\n.checkout-item:last-of-type {\n    border-bottom: none;\n}\n\n.checkout-item span,\n.checkout-item div {\n    color: var(--text-mid);\n    font-size: 0.9rem;\n}\n\n/* ─── Total Amount ────────────────────────────────────────────────────── */\n.total-amount {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 14px;\n    padding: 12px 16px;\n    background: var(--navy);\n    border-radius: var(--radius-md);\n    color: #ffffff;\n    font-size: 1.05rem;\n    font-weight: 700;\n    letter-spacing: 0.01em;\n}\n\n/* ─── Payment Options ─────────────────────────────────────────────────── */\n.payment-options {\n    text-align: left;\n    margin-bottom: 8px;\n}\n\n.payment-options h3,\n.payment-options > strong,\n.payment-options > p {\n    font-size: 0.8rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--teal);\n    margin-bottom: 10px;\n    display: block;\n}\n\n.payment-options label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin: 8px 0;\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: var(--text-dark);\n    padding: 10px 14px;\n    border-radius: var(--radius-md);\n    border: 1.5px solid var(--border);\n    cursor: pointer;\n    transition: border-color 0.15s, background 0.15s;\n}\n\n.payment-options label:hover {\n    border-color: var(--teal);\n    background: var(--teal-glow);\n}\n\n.payment-options input[type=\"radio\"] {\n    accent-color: var(--teal);\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n}\n\n/* ─── Buttons ─────────────────────────────────────────────────────────── */\n.checkout-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 22px;\n}\n\n.back-button-container {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 12px;\n}\n\n.back-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: #f0f5f9;\n    border: 1.5px solid var(--border);\n    color: var(--text-mid);\n    padding: 8px 16px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    font-family: 'DM Sans', sans-serif;\n    cursor: pointer;\n    border-radius: var(--radius-md);\n    transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.back-button:hover {\n    background: var(--border);\n    border-color: var(--teal);\n    color: var(--navy);\n}\n\n/* Primary pay button */\n.pay-button {\n    background: linear-gradient(135deg, var(--navy) 0%, var(--teal) 100%);\n    color: #fff;\n    border: none;\n    border-radius: var(--radius-md);\n    padding: 14px 28px;\n    font-size: 1rem;\n    font-weight: 700;\n    font-family: 'DM Sans', sans-serif;\n    letter-spacing: 0.02em;\n    cursor: pointer;\n    box-shadow: var(--shadow-btn);\n    transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;\n    margin-top: 10px;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n}\n\n.pay-button::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: rgba(255,255,255,0);\n    transition: background 0.15s;\n}\n\n.pay-button:hover:not(:disabled)::after {\n    background: rgba(255,255,255,0.08);\n}\n\n.pay-button:hover:not(:disabled),\n.pay-button:focus:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 22px rgba(45, 125, 154, 0.45);\n}\n\n.pay-button:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.pay-button:disabled {\n    background: #c8d8e4;\n    cursor: not-allowed;\n    color: #8faabb;\n    box-shadow: none;\n    opacity: 0.75;\n}\n\n/* View Orders button — same visual weight as pay */\n.view-orders-button {\n    background: linear-gradient(135deg, var(--navy) 0%, var(--teal) 100%);\n    color: #fff;\n    border: none;\n    border-radius: var(--radius-md);\n    padding: 14px 28px;\n    font-size: 1rem;\n    font-weight: 700;\n    font-family: 'DM Sans', sans-serif;\n    letter-spacing: 0.02em;\n    cursor: pointer;\n    box-shadow: var(--shadow-btn);\n    transition: transform 0.15s, box-shadow 0.15s;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n}\n\n.view-orders-button:hover,\n.view-orders-button:focus {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 22px rgba(45, 125, 154, 0.45);\n}\n\n.view-orders-button:active {\n    transform: translateY(0);\n}\n\n/* ─── Responsive ──────────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n    .checkout-container {\n        margin: 80px 12px 24px;\n        padding: 24px 20px 20px;\n        border-radius: var(--radius-md);\n        box-shadow: var(--shadow-card);\n    }\n\n    .checkout-item {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 3px;\n        padding: 10px 0;\n    }\n\n    .payment-options label {\n        font-size: 0.9rem;\n    }\n\n    .pay-button,\n    .view-orders-button {\n        padding: 12px 20px;\n        font-size: 0.97rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .checkout-container {\n        margin: 72px 8px 20px;\n        padding: 20px 14px 16px;\n        border-radius: 12px;\n    }\n\n    .checkout-container h2,\n    .checkout-container h1 {\n        font-size: 1.45rem;\n    }\n\n    .total-amount {\n        font-size: 0.97rem;\n    }\n\n    .back-button {\n        padding: 7px 13px;\n        font-size: 0.85rem;\n    }\n}\n\n@media (max-width: 320px) {\n    .checkout-container {\n        margin: 68px 4px 16px;\n        padding: 16px 10px 14px;\n    }\n\n    .pay-button,\n    .view-orders-button {\n        padding: 11px 16px;\n        font-size: 0.92rem;\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .checkout-container {\n        max-width: 88%;\n        margin: 100px auto 40px;\n    }\n}\n\n@media (min-width: 1025px) and (max-width: 1280px) {\n    .checkout-container {\n        max-width: 640px;\n        margin: 100px auto 40px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
